// extracted by mini-css-extract-plugin
export default {"create-report-filters-popup":"CreateReportFiltersPopup_create-report-filters-popup__3XkGJ","popup-header":"CreateReportFiltersPopup_popup-header__1OA6m"};